/* eslint-disable no-restricted-syntax */
// We alias RampApp into EcommApp to make storybook work
// as the scripts rely on "EcommApp" specifically being the app name
// export { RampApp, RampApp as EcommApp } from './service-setup/RampApp';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo, root } from '@estee/elc-universal-utils';

export { RampApp } from './service-setup/RampApp';
export { RampService } from './service-setup/RampService';

import { ServiceManifest } from './manifest';

diContainer.get(serviceNames.rampService).register();

setupServiceInfo(__serviceInfo__);
const { name } = __serviceInfo__;

//@ts-ignore
root.ServiceRegistry[name] = ServiceManifest;
